import EmblaCarousel from './embla-carousel.js';

const initEmbla = emblaNode => {
    if (emblaNode.emblaApi) return;
    const options = JSON.parse(emblaNode.dataset.options ?? '{}');
    const viewPortNode = emblaNode.querySelector('.embla__viewport');
    const prevButtonNode = emblaNode.querySelector('.embla__button--prev');
    const nextButtonNode = emblaNode.querySelector('.embla__button--next');
    
    const embla = EmblaCarousel(viewPortNode, options);

    emblaNode.emblaApi = embla;

    if (prevButtonNode && nextButtonNode) {
      addPrevNextBtnsClickHandlers(emblaNode, embla, prevButtonNode, nextButtonNode);
    }
    addExternalControls(embla);
};

document.querySelectorAll('.embla').forEach(initEmbla);
document.addEventListener('product-grid:updated', () => document.querySelectorAll('.embla').forEach(initEmbla));

function addExternalControls(emblaApi) {
  const slideNodes = emblaApi.slideNodes();
  slideNodes.forEach(slideNode => {
    const carouselControlId = slideNode.dataset.carouselControlId;
    if (!carouselControlId) {
      return;
    }

    const controlElement = document.getElementById(carouselControlId);
    const idPart = carouselControlId.split('-')[1];
    const siblingControlElements = document.querySelectorAll(`[id^="product-${idPart}-"]:not(#${carouselControlId})`);
    controlElement.addEventListener('change', () => {
      if (controlElement.checked) {
        const index = Array.from(slideNodes).indexOf(slideNode);
        emblaApi.scrollTo(index);

        siblingControlElements.forEach(siblingControlElement => {
          if (siblingControlElement.checked) {
            siblingControlElement.checked = false;
            siblingControlElement.dispatchEvent(new Event('change'));
          }
        });
      }
    });
  });

  emblaApi.on('select', () => {
    const currentSlide = slideNodes[emblaApi.selectedScrollSnap()];
    const carouselControlId = currentSlide.dataset.carouselControlId;
    if (!carouselControlId) {
      return;
    }

    const controlElement = document.getElementById(carouselControlId);

    if (!controlElement.checked) {
      controlElement.checked = true;
      controlElement.dispatchEvent(new Event('change'));

      const idPart = carouselControlId.split('-')[1];
      const siblingControlElements = document.querySelectorAll(`[id^="product-${idPart}-"]:not(#${carouselControlId})`);
      siblingControlElements.forEach(siblingControlElement => {
        if (siblingControlElement.checked) {
          siblingControlElement.checked = false;
          siblingControlElement.dispatchEvent(new Event('change'));
        }
      });
    }
  });
}

function addTogglePrevNextBtnsActive(emblaNode, emblaApi, prevBtn, nextBtn) {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
      else prevBtn.setAttribute('disabled', 'disabled')
  
      if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
      else nextBtn.setAttribute('disabled', 'disabled')

      if (!emblaApi.canScrollNext() && !emblaApi.canScrollPrev()) emblaNode.querySelector('.embla__controls').style.display = 'none';
    }
  
    emblaApi
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  
    return () => {
      prevBtn.removeAttribute('disabled')
      nextBtn.removeAttribute('disabled')
    }
  }
  
function addPrevNextBtnsClickHandlers(emblaNode, emblaApi, prevBtn, nextBtn) {
    const scrollPrev = () => {
      emblaApi.scrollPrev()
    }
    const scrollNext = () => {
      emblaApi.scrollNext()
    }
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)
  
    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
      emblaNode,
      emblaApi,
      prevBtn,
      nextBtn
    )
  
    return () => {
      removeTogglePrevNextBtnsActive()
      prevBtn.removeEventListener('click', scrollPrev, false)
      nextBtn.removeEventListener('click', scrollNext, false)
    }
  }
  